import CircularProgress from '@mui/material/CircularProgress';
import { OverlayRoot } from '../OverlayRoot/OverlayRoot';

export const LoadingOverlay = () => {
  return (
    <OverlayRoot>
      <CircularProgress />
    </OverlayRoot>
  );
};
